import {
  GET_EMPLOYEES,
  GET_EMPLOYEES_FAIL,
  GET_EMPLOYEES_SUCCESS,
  GET_AUTH_USER,
  GET_AUTH_USER_FAIL,
  GET_AUTH_USER_SUCCESS,
  ADD_NEW_EMPLOYEE,
  ADD_EMPLOYEE_SUCCESS,
  ADD_EMPLOYEE_FAIL,
  UPDATE_EMPLOYEE,
  UPDATE_EMPLOYEE_SUCCESS,
  UPDATE_EMPLOYEE_FAIL,
  DELETE_EMPLOYEE,
  DELETE_EMPLOYEE_SUCCESS,
  DELETE_EMPLOYEE_FAIL,
  GET_EMPLOYEE_DETAIL,
} from "./actionTypes"

export const getEmployees = props => ({
  type: GET_EMPLOYEES,
  payload: props,

})

export const getEmployeesSuccess = employees => ({
  type: GET_EMPLOYEES_SUCCESS,
  payload: employees,
})

export const getEmployeesFail = error => ({
  type: GET_EMPLOYEES_FAIL,
  payload: error,
})

export const getAuthUsers = auth => ({
  type: GET_AUTH_USER,
  payload: auth,

})

export const getAuthUsersSuccess = auth => ({
  type: GET_AUTH_USER_SUCCESS,
  payload: auth,
})

export const getAuthUsersFail = error => ({
  type: GET_AUTH_USER_FAIL,
  payload: error,
})

export const addNewEmployee = employee => ({
  type: ADD_NEW_EMPLOYEE,
  payload: employee,
})

export const addEmployeeSuccess = employee => ({
  type: ADD_EMPLOYEE_SUCCESS,
  payload: employee,
})

export const addEmployeeFail = error => ({
  type: ADD_EMPLOYEE_FAIL,
  payload: error,
})

export const updateEmployee = employee => ({
  type: UPDATE_EMPLOYEE,
  payload: employee,
})

export const updateEmployeeSuccess = employee => ({
  type: UPDATE_EMPLOYEE_SUCCESS,
  payload: employee,
})

export const updateEmployeeFail = error => ({
  type: UPDATE_EMPLOYEE_FAIL,
  payload: error,
})

export const deleteEmployee = employee => ({
  type: DELETE_EMPLOYEE,
  payload: employee,
})

export const deleteEmployeeSuccess = employee => ({
  type: DELETE_EMPLOYEE_SUCCESS,
  payload: employee,
})

export const deleteEmployeeFail = error => ({
  type: DELETE_EMPLOYEE_FAIL,
  payload: error,
})

export const getEmployeeDetails = employee => ({
  type: GET_EMPLOYEE_DETAIL,
  payload: employee,
})

export const getEmployeeDetailFail = error => ({
  type: GET_EMPLOYEE_DETAIL_FAIL,
  payload: error,
})


export const getEmployeeDetailSuccess = employee => ({
  type: GET_EMPLOYEE_DETAIL_SUCCESS,
  payload: employee,
})


